<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> build </v-icon>
      <span :class="ui.textHeadline"> Work </span>
      <v-spacer/>
      <WorkRequestNew
      :data="{btnTitle: 'New', btnSize: 'iconAdd'}"
      v-if="
      this.licenceOK &&
      this.userOK &&
      this.getUser.pref.select.fauth !== null &&
      this.enableAccessAuthCreate('W1') &&
      this.enableAccessAuthSearch('W1')
      "/>
      <GeneralHelp :data="{tag: 'W1', size: 'icon', title: null}"/>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Project or maintenance work cost and carbon palan to ensure safe execution.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <Search :data="{title: 'Work Search', tag: 'W1'}"
        v-if="this.enableAccessAuthSearch('W1')"/>
        <v-spacer/>
        <GetRegisterListPage :data="{tag: 'K6', tagd: 'W1', tags: 'W1'}"
        v-if="
        this.licenceOK &&
        this.userOK &&
        this.enableAccessAuthSearch('W1')"/>
        <v-btn :color="ui.colorWarning" flat dark
        v-if="this.getUser.pref.select.fauth === null">
          <v-icon left>
            info
          </v-icon>
          Select Facility
        </v-btn>
        <WorkRequestNew
        :data="{btnTitle: 'New Work Request', btnSize: 'flat'}"
        v-if="
        this.licenceOK &&
        this.userOK &&
        this.getUser.pref.select.fauth !== null &&
        this.enableAccessAuthCreate('W1') &&
        !this.enableAccessAuthSearch('W1')
        "/>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import WorkRequestNew from "@/work/request/components/WorkRequestNew";
import Search from "@/data/search/components/Search";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import GeneralHelp from "@/frame/help/components/GeneralHelp";
// import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import { mapGetters } from "vuex";

export default {
  mixins: [apptheme, licenceFunctions, adminFunctions, accessFunctions],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser"])
  },
  components: {
    GetRegisterListPage,
    WorkRequestNew,
    Search,
    GeneralHelp
  },
  data() {
    return {
      valid: true
    };
  }
};
</script>
